import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  TextField,
  Paper,
  Typography,
  Avatar,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link
} from "@mui/material";
import ConversationGateway from '../../gateway/conversation/ConversationGateway';
import ReactMarkdown from 'react-markdown';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';
import Autocomplete from '@mui/material/Autocomplete';

const CenteringContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '90vh',
  backgroundColor: theme.palette.background.default,
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
  borderBottomLeftRadius: '10px',
  borderBottomRightRadius: '10px',
  boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
}));

const ChatContainer = styled(Box)(({ theme }) => ({
  height: "80vh",
  width: "50vw",
  display: "flex",
  flexDirection: "column",
  position: "relative",
  background: 'white',
  // background: 'rgb(9,9,121)',
  // background: 'linear-gradient(124deg, rgba(9,9,121,1) 0%, rgba(0,80,255,1) 33%, rgba(0,215,37,0.9) 100%)'
}));

const MessagesContainer = styled(Paper)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column-reverse',
  justifyContent: 'flex-start',
  overflowY: "auto",
  scrollbarWidth: "none",
  scrollToBottom: "smooth",
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  borderBottomLeftRadius: '0px',
  borderBottomRightRadius: '0px',
  // Hide scrollbar for webkit browsers
  '&::-webkit-scrollbar': {
    display: 'none',
    width: '0px !important',
    background: 'transparent',
    '-webkit-appearance': 'none'
  },
  // Hide scrollbar for non-webkit browsers
  '-ms-overflow-style': 'none', // IE and Edge
  'scrollbar-width': 'none', // Firefox
}));

const MessageBubble = styled(Box)(({ theme, isuser }) => ({
  display: "flex",
  alignItems: "flex-start",
  marginBottom: theme.spacing(2),
  flexDirection: isuser ? "row-reverse" : "row",
  gap: theme.spacing(1)
}));

const MessageContent = styled(Paper)(({ theme, isuser }) => ({
  padding: theme.spacing(1.5),
  maxWidth: "70%",
  backgroundColor: isuser ? "rgba(207, 32, 47, .9 )" : theme.palette.white,
  color: isuser ? theme.palette.primary.contrastText : theme.palette.text.primary,
  borderRadius: theme.spacing(2),
  boxShadow: 'none',
  "& .markdown": {
    "& p": {
      margin: 0
    },
    "& strong": {
      fontWeight: 600
    },
    "& em": {
      fontStyle: "italic"
    },
    "& code": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      padding: "2px 4px",
      borderRadius: "4px"
    },
    "& blockquote": {
      borderLeft: "4px solid",
      borderColor: isuser ? "rgba(255, 255, 255, 0.3)" : "rgba(0, 0, 0, 0.2)",
      paddingLeft: theme.spacing(1),
      margin: theme.spacing(1, 0)
    }
  }
}));

const InputContainer = styled(Box)(({ theme }) => ({
  left: 0,
  right: 10,
  display: "flex",
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  backdropFilter: "blur(10px)",
  borderBottomLeftRadius: '4px',
  borderBottomRightRadius: '4px',
  zIndex: 1000
}));

const MessageImage = styled("img")({
  maxWidth: "100%",
  borderRadius: "8px",
  marginTop: "8px"
});

const pulsate = {
  '@keyframes pulsate': {
    '0%': {
      transform: 'scale(1)',
      opacity: 1,
    },
    '50%': {
      transform: 'scale(1.1)',
      opacity: 0.5,
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 1,
    },
  },
};

const ConversationInterface = ({config, searchText, handleSearchChange, zipCode, criteria, handleCriteriaChange, sharedMessages, broadcastSharedMessages}) => {
  const gateway = new ConversationGateway({ config });
  const [suggestions, setSuggestions] = useState([]);
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Hello, I am an intelligent consumer research guidance assistant. What type of vehicle are you interested in exploring?",
      sender: "responder",
      timestamp: new Date().toLocaleTimeString(),
    },
  ]);
  const [newMessage, setNewMessage] = useState("");
  const [llmMessages, setLLMMessages] = useState([{
    content: "Hello, I am an intelligent consumer research guidance assistant. What type of vehicle are you interested in exploring?",
    role: "assistant"
  }]);
  const [isStreaming, setIsStreaming] = useState(false);
  const [isListening, setIsListening] = useState(false);
  //const [inventoryNoticeDisplayed, setInventoryNoticeDisplayed] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    //   const delay = setTimeout(() => {
    //     if(searchText) {
    //         const fetchSuggestions = async () => {
    //             try {
    //                 const response = await axios.get(config.SuggestionAPI.url + `?search=${searchText}`);
    //                 setSuggestions(response.data);
    //             } catch (error) {
    //                 console.error('Error fetching suggestions:', error);
    //             }
    //         };
    //         fetchSuggestions();
    //     } else {
    //         setSuggestions([]);
    //     }
    //   }, 1000);

    // return () => clearTimeout(delay);
  }, [searchText]);

  useEffect(() => {
    if (sharedMessages.length === 0) {
      setLLMMessages([{
        content: "Hello, I am an intelligent consumer research guidance assistant. What type of vehicle are you interested in exploring?",
        role: "assistant"
      }]);
      setMessages([
        {
          id: 1,
          text: "Hello, I am an intelligent consumer research guidance assistant. What type of vehicle are you interested in exploring?",
          sender: "responder",
          timestamp: new Date().toLocaleTimeString(),
        },
      ]);
      //setInventoryNoticeDisplayed(false);
    }
  }, [sharedMessages]);


  const handleSend = async () => {
    if (newMessage.trim()) {
        const message = {
            id: messages.length + 1,
            text: newMessage.replace(/(https?:\/\/[^\s]+)/g, '[$1]($1)'),
            sender: "user",
            timestamp: new Date().toLocaleTimeString()
        };
        let newMessages = [message, ...messages];
        setMessages(newMessages);
        setNewMessage("");
        const llmMessage = {
          content: newMessage,
          role: "user"
        };
        let newLLMMessages = [...llmMessages, llmMessage];
        setLLMMessages(newLLMMessages);

        handleSearchChange(null, '');

        let zipCodeMessage = {
          content: 'The user is located at Zip Code ' + zipCode + '. Use the information to provide relevant consumer research guidance. Ignore the Zip Code if other location information is provided by the user.',
          role: 'system'
        };
        let preparedMessages = [zipCodeMessage, ...newLLMMessages];

        let responseMessage = '';
        const responderMessage = {
            id: messages.length + 2,
            text: '...',
            sender: "responder",
            timestamp: new Date().toLocaleTimeString()
        };
        //handleCriteriaChange(response);
        setMessages(prev => [responderMessage, ...prev]);

        setIsStreaming(true);
        await gateway.chat(preparedMessages, (chunk) => {
          responseMessage += chunk.content;
          
          let msg = responseMessage.replace(/(https?:\/\/[^\s]+)/g, "[$1]($1)");
          
          setMessages(prev => {
            const updateResponseMessage = [...prev];
            updateResponseMessage[0] = {
              ...updateResponseMessage[0],
              text: msg
            };
            return updateResponseMessage;
          });
      });
      setIsStreaming(false);

      const llmResponseMessage = {
        content: responseMessage,
        role: "assistant"
      };
      let newLLMResponseMessages = [...preparedMessages, llmResponseMessage];
      setLLMMessages(newLLMResponseMessages);

      if (newLLMResponseMessages.length > 4) {
        //setInventoryNoticeDisplayed(true);

        broadcastSharedMessages(newLLMResponseMessages);

        const messageToCleanup = 'inventorynotice';

        const responderMessage = {
            id: messageToCleanup,
            text: 'Inventory is being located based on your preferences. Notice the icon highlighting below. Inventory will continue updating as we narrow in on your preferences.',
            sender: "responder",
            timestamp: new Date().toLocaleTimeString()
        };
        //handleCriteriaChange(response);
        setMessages(prev => [responderMessage, ...prev]);

        setTimeout(() => {
          //cleanup message
          setMessages(prev => {
            return prev.filter(message => message.id !== messageToCleanup);
          });
        }, 5000);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleVoiceInput = () => {
    if (!('webkitSpeechRecognition' in window)) {
      alert('Your browser does not support speech recognition. Please use a supported browser.');
      return;
    }

    const recognition = new window.webkitSpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = true;
    recognition.lang = 'en-US';

    recognition.onstart = () => {
      setIsListening(true);
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      handleSearchChange(null, transcript);
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error', event);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.start();
  };

  return (
    <CenteringContainer elevation={4}>
      <ChatContainer>
        <MessagesContainer elevation={0}>
          <div ref={messagesEndRef} />
          {messages.map((message) => (
            <MessageBubble key={message.id} isuser={message.sender === "user" ? "true" : undefined} >
              <Avatar
                src={message.sender === "user" ? "./UserIcon.svg" : "./Icon.svg"}
                alt={message.sender}
                sx={{ 
                  marginTop: 4,
                  animation: message.sender !== "user" && isStreaming ? 'pulsate 1s infinite' : 'none',
                  ...pulsate
                 }}
              />
              <MessageContent isuser={message.sender === "user" ? "true" : undefined} elevation={1}>
                <Box variant="markdown">
                  <ReactMarkdown>{message.text}</ReactMarkdown>
                </Box>
                {message.image && (
                  <MessageImage src={message.image} alt="Message attachment" />
                )}
                {message.table && (
                  <TableContainer component={Paper} sx={{ mt: 1 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Product</TableCell>
                          <TableCell align="right">Sales</TableCell>
                          <TableCell align="right">Revenue</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {message.table.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell>{row.product}</TableCell>
                            <TableCell align="right">{row.sales}</TableCell>
                            <TableCell align="right">{row.revenue}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
                {message.link && (
                  <Link href={message.link} target="_blank" sx={{ display: "block", mt: 1 }}>
                    View Location Details
                  </Link>
                )}
                <Typography variant="caption" display="block" sx={{ opacity: 0.7, mt: 1 }}>
                  {message.timestamp}
                </Typography>
              </MessageContent>
            </MessageBubble>
          ))}
        </MessagesContainer>

        <InputContainer>
          <Autocomplete
            freeSolo
            options={suggestions}
            value={searchText}
            forcePopupIcon={false}
            fullWidth
            disableClearable
            onInputChange={(event, value) => handleSearchChange(event, value)}
            getOptionLabel={(option) => typeof option === 'string' || option instanceof String ? option : option.value}
            filterOptions={x => x}
            renderInput={(params) => (
              <TextField
                {...params} 
                fullWidth
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyDown={handleKeyDown}
                label="Search with AI - Built with Llama ..."
                variant="outlined"
                size="small"
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton 
                                onClick={handleVoiceInput} 
                                sx={{
                                  backgroundColor: isListening ? 'darkred' : 'rgb(207, 32, 47)',
                                  borderRadius: '50%',
                                  width: '30px',
                                  height: '30px',
                                  marginLeft: '10px',
                                  marginRight: '10px',
                                  zIndex: 1001,
                                  '&:hover': {
                                      backgroundColor: 'darkred',
                                  }
                                }}>
                                  <FontAwesomeIcon icon={faMicrophone} color="white" />
                            </IconButton>
                            <IconButton 
                              disabled={!newMessage.trim()} 
                              onClick={(event) => handleSend(event, newMessage)} 
                              sx={{
                                backgroundColor: 'rgb(207, 32, 47)',
                                borderTopLeftRadius: '0%',
                                borderBottomLeftRadius: '0%',
                                borderTopRightRadius: '4px',
                                borderBottomRightRadius: '4px',
                                width: '43px',
                                height: '43px',
                                marginRight: '-10px',
                                zIndex: 1001,
                                '&:hover': {
                                    backgroundColor: 'darkred',
                                },
                                '&:disabled': {
                                    backgroundColor: "rgb(169, 2, 2)",
                                }
                              }}>
                                <img src="/WhiteStars.svg" alt="search" style={{ width: '30px', height: '30px'}} />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                slotProps= {{
                  inputLabel: {style: {color: 'rgb(207, 32, 47)'}}
                }}              
                sx={{
                  '& .MuiOutlinedInput-root': {
                      'fieldset': {
                        borderWidth: '2px',
                      },
                      '&:hover fieldset': {
                          borderColor: 'rgb(207, 32, 47)',
                          borderWidth: '2px'
                      },
                      '&.Mui-focused fieldset': {
                          borderColor: 'rgb(207, 32, 47)',
                          borderWidth: '2px'
                      },
                  },
              }}
              />
            )}
          />
        </InputContainer>
      </ChatContainer>
    </CenteringContainer>
  );
};

export default ConversationInterface;